import { render, staticRenderFns } from "./InputChoice.vue?vue&type=template&id=2bb8589d&"
import script from "./InputChoice.vue?vue&type=script&lang=ts&"
export * from "./InputChoice.vue?vue&type=script&lang=ts&"
import style0 from "./InputChoice.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports